import useShared from "../../../../../shared/_common/_shared";


export default function AntosEmptyData() {
    const {IconCommon} = useShared()
    return (
        <div className={"text-center"}>
            <IconCommon iconName={"empty"} className={"empty-data"} title={"noData"} isAlwaysInActive={true}/>
        </div>
    )
}